import { styled } from '@mui/material';
import { ReactComponent as BaseElamaIcon } from '../../../assets/images/elama.svg';

export const ElamaIcon = styled(BaseElamaIcon)(({ theme }) => ({
  width: 20,
  height: 20,
  '& path:nth-of-type(2)': {
    fill: theme.custom.palette.primary.default,
  },
}));
